import React from "react";
import SuperUserHomePageUI from "../../../templates/SuperUserHomePageUI";
import CardUI from "../../../widgets/layout/CardUI";
import LRTableActionsUI from "../../../widgets/layout/LRTableActionsUI";
import IconButtonUI from "../../../widgets/action/IconButtonUI";
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI";
import EmptyListUI from "../../../widgets/output/EmptyListUI";
import VendorDiligenceCreateModalSF from "./VendorDiligenceCreateModalSF";

const VendorDiligencePageUI = ({
  context,
  createMode,
  onCreateDiligenceClick,
  onCancelDiligenceCreate,
  onRefreshClick,
  vendorDiligenceList,
  loadingVendorDiligence,
  formatDate
}) => (
  <SuperUserHomePageUI
    context={context}
    className="pg_su_ven"
    topnav="accounts"
    headerText="Vendor Diligence"
    centered={false}
    page="vendorDiligence"
    dimension='w1600'
  >
    <div className="su_fee">
      <LRTableActionsUI
        location="top"
        left={
          <span className="g_flex_left g_flex_h">
            <IconButtonUI icon="icon-refresh" onClick={onRefreshClick} />
            <IconButtonUI icon="icon-plus" onClick={onCreateDiligenceClick} />
            <span className="g_m_left_100 g_large">
              <b>Vendor Diligence</b>
            </span>
          </span>
        }
      />
    </div>

    <CardUI context={context} className="g_m_top_20" title="Vendor Diligence Reports">
      {loadingVendorDiligence ? (
        <div style={{ padding: "16px" }}>
          <SpinnerComponentUI context={context} />
        </div>
      ) : (
        <div style={{ maxHeight: '500px', overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {vendorDiligenceList && vendorDiligenceList.length > 0 ? (
            <table className='table_cr table' style={{ minWidth: '1000px' }}>
              <thead className='g_sticky_header'>
                <tr>
                  <th>S.No</th>
                  <th>Vendor Name</th>
                  <th>CIN</th>
                  <th>Status</th>
                  <th>Reference ID</th>
                  <th>Date Created</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody>
                {vendorDiligenceList.map((item, index) => (
                  <tr key={`vendor-diligence-${item.vendorDiligenceId}`}>
                    <td>{index + 1}</td>
                    <td>{item.vendorName}</td>
                    <td>{item.cin}</td>
                    <td>
                      <span className={`status-badge ${item.reportStatus}`}>
                        {item.reportStatus === "not_initiated" ? "Not Initiated" : 
                         item.reportStatus === "collected" ? "Collected" : 
                         item.reportStatus === "skipped" ? "Skipped" :
                         item.reportStatus === "requested" ? "Requested" : 
                         item.reportStatus === "failed" ? "Failed" :
                         item.reportStatus}
                      </span>
                    </td>
                    <td>{item.referenceId || 'N/A'}</td>
                    <td>{formatDate(item.dateCreated)}</td>
                    <td>{formatDate(item.dateUpdated)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <EmptyListUI
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No Vendor Diligence Reports Found'
            />
          )}
        </div>
      )}
    </CardUI>

    <VendorDiligenceCreateModalSF
      context={context}
      createMode={createMode}
      onCancelClick={onCancelDiligenceCreate}
      onRefreshClick={onRefreshClick}
    />
  </SuperUserHomePageUI>
);

export default VendorDiligencePageUI;